/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';
let exports = {};

// ====================== 虚拟零售商 ======================

exports.getVirtualRetailerList = function (data, callback) {// 获取 - 虚拟零售商列表
    api.post('/retailer/virtual/retailer/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/virtual.js
// module id = 409
// module chunks = 0